module.exports = __webpack_public_path__ + "static/media/need-doctor.26668402.jpg";